import React from 'react';
import { additionalIntegrations, integrations } from '../../data/integrations';
export function IntegrationsSection() {
  return <section id="integrations" className="scroll-mt-6 border-y border-[#A6B6F8]/50 bg-white" data-id="element-79" data-mp="aaso73ykst84">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-80" data-mp="ozf4p8zxvr0x">
        <div className="mx-auto max-w-2xl text-center" data-id="element-81" data-mp="k6lw2a1cnyjk">
          <h2 className="text-3xl font-bold tracking-[-0.035em] sm:text-4xl" data-id="element-82" data-mp="xysfc4zsuln8">
            Seamlessly integrates with your accounting software.
          </h2>
          <p className="mt-4 text-base leading-7 text-[#3A3A3A]" data-id="element-83" data-mp="twnofe0qk34a">
            Over 300 accounting software integrations available. Select your
            provider and Credit Manager will guide you through connecting it.
          </p>
        </div>

        <ul className="mx-auto mt-12 grid max-w-3xl grid-cols-1 gap-5 sm:grid-cols-3" data-id="element-84" data-mp="39o365aw5me8q">
          {integrations.map(integration => <li key={integration.name} className="flex flex-col items-center justify-center gap-4 rounded-2xl border border-[#A6B6F8]/50 bg-white px-6 py-9" data-id="element-85" data-mp="34qjnlysfbfaz">
              <img src={integration.logo} alt={`${integration.name} logo`} width={48} height={48} className="h-12 w-12" loading="lazy" data-id="element-86" data-mp="3h5ah3k2t325z" />
              <span className="text-sm font-bold text-[#041F60]" data-id="element-87" data-mp="3uvvzz8s9fc3v">
                {integration.name}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-9 max-w-2xl text-center text-sm leading-6 text-stone-600" data-id="element-88" data-mp="3o1fxea7lm72">
          Plus {additionalIntegrations.slice(0, -1).join(', ')} and{' '}
          {additionalIntegrations[additionalIntegrations.length - 1]}. Using
          something else? Let us know — further connectors are in development.
        </p>
      </div>
    </section>;
}